import { faDownload, IconDefinition } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Center, Text, useMantineTheme } from '@mantine/core'
import React from 'react'

import { DisplayAssetProps } from '../../../../types/preview'
import ErrorReplace from '../../../ErrorReplace'
import LoaderReplace from '../../../LoaderReplace'
import RenderReplaceWrapper from '../../../RenderReplaceWrapper'
import useBase64Conversion from '../../../useBase64Conversion'
import CarouselView from '../CarouselView'

const FullscreenDisplay = ({
  asset,
  maxWidth,
  openInModal,
  height,
  icon,
  modalOpen,
  errorText,
}: DisplayAssetProps & {
  icon: IconDefinition
  errorText: string
}): React.ReactElement => {
  const theme = useMantineTheme()
  const { blobDownloading, blobUrl, invalidBlobUrl } = useBase64Conversion({
    asset,
  })

  if (blobDownloading) {
    return <LoaderReplace />
  }

  if (!asset.public_url && invalidBlobUrl) {
    return <ErrorReplace asset={asset} maxWidth={maxWidth} error={errorText} />
  }

  if (typeof asset.public_url === 'string' || typeof blobUrl === 'string') {
    return (
      <RenderReplaceWrapper
        backgroundColor={theme.colors[theme.primaryColor][0]}
      >
        <Center style={{ flexDirection: 'column' }}>
          <CarouselView
            asset={asset}
            openInModal={openInModal}
            height={height}
            maxWidth={maxWidth}
            icon={icon}
            modalOpen={modalOpen}
          />
          <Text mt="lg" align="center">
            Für dieses Dateiformat können wir Ihnen leider keine Vorschau
            anbieten. Bitte laden Sie die Datei herunter um Ihren Inhalt zu
            sehen.
          </Text>
          <Button
            size="xl"
            mt="lg"
            leftIcon={<FontAwesomeIcon icon={faDownload} />}
            component="a"
            download={asset.name}
            href={asset.public_url ?? (blobUrl as string)}
          >
            Herunterladen
          </Button>
        </Center>
      </RenderReplaceWrapper>
    )
  }

  return <></>
}

export default FullscreenDisplay
